import { useWindowSizeThreshold } from "@/Hooks/useWindowSizeThreshold";
import { Breakpoint } from "@/Types/Enums/Breakpoint";

export const useIsMobile = () => {
  return useWindowSizeThreshold(Breakpoint.MD);
};
